// For storybook demonstration & visualization only!
// Content needs to be overwritten with new molecule passing custom props to this atom.
// Do not use this component directly for UI composition.
// Examples: <LenderCTA /> OR <CalculatorCTA />

import React from 'react';
import PropTypes from 'prop-types';
import SourceIdLink from '../../Molecules/SourceIdLink';

const ActionBanner = ({ content, testIds, css }) => (
    <div
        data-testid={testIds?.BANNER_CONTAINER}
        className={css?.bannerWrapper || css.defaultWrapper}
    >
        {content?.label && (
            <h2
                data-testid={testIds?.BANNER_HEADLINE}
                className={css?.bannerHeadline}
            >
                {content.label}
            </h2>
        )}
        {content?.sublabel && (
            <p
                data-testid={testIds?.BANNER_DESCRIPTION}
                className={css?.bannerDescription}
            >
                {content.sublabel}
            </p>
        )}
        {content?.submenu?.nodes && (
            <ul data-testid={testIds?.BANNER_LIST} className={css?.bannerList}>
                {content?.submenu?.nodes?.length &&
                    content.submenu.nodes.map((a) => (
                        <div
                            data-testid={
                                a.testId ||
                                `${testIds?.BANNER_BUTTON}${a.databaseId}`
                            }
                            className={css?.bannerItem}
                            key={`${testIds?.BANNER_BUTTON}${a.databaseId}`}
                        >
                            <li>
                                <SourceIdLink href={a.src}>
                                    <span>{a.label}</span>
                                </SourceIdLink>
                            </li>
                        </div>
                    ))}
            </ul>
        )}
    </div>
);

ActionBanner.propTypes = {
    /** Content for headlines and CTA btns */
    content: PropTypes.object.isRequired,
    /** Custom data test ids override */
    testIds: PropTypes.object.isRequired,
    /** Custom styles override */
    css: PropTypes.object.isRequired,
};

export default ActionBanner;
